import * as React from "react";
import {renderApp} from "@ui-seeker/app";
import {initAnalytics} from "@analytics";

import AppTest from "./App";

// Product analytics (src/@analytics). Fail-silent and fire-and-forget: it can neither throw here
// nor slow the first render. Route tracking is mounted in App.jsx (<AnalyticsRouter/>).
initAnalytics();

renderApp(AppTest, {
    useServiceWorker: process?.env?.NODE_ENV === 'production'
});